import Logo from "@/components/feature/Logo";

export default function Closing() {
  return (
    <section className="relative overflow-hidden bg-primary-950 pt-16 pb-20 md:pt-20 md:pb-28">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="animate-ocean-drift absolute -left-24 top-0 h-[380px] w-[380px] rounded-full bg-secondary-700/20 blur-3xl" />
        <div className="absolute -right-20 bottom-0 h-[320px] w-[320px] rounded-full bg-primary-800/40 blur-3xl" />
      </div>

      <div className="pointer-events-none absolute inset-x-0 top-0" aria-hidden="true">
        <div className="mx-auto h-px w-2/3 bg-gradient-to-r from-transparent via-accent-400/25 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-4 text-center md:px-8">
        <Logo variant="light" size="lg" />
        <p className="ocean-label mt-10 text-[10px] text-background-100/70 md:text-[11px]">
          Ocean Companhia de Comércio LTDA
        </p>
        <span className="mt-6 block h-px w-24 bg-accent-500/70" />
        <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-100/70 md:text-base">
          Importação e comercialização de produtos para o mercado nacional.
        </p>
      </div>
    </section>
  );
}